<template>
  <div
    v-for="module in modules"
    :key="module.id"
    class="card border-start border-start-secondary border-start-width-2"
  >
    <div class="card-header d-flex align-items-center py-0">
      <div>
        <h6 class="pt-3 mb-1 text-primary">{{ module.name }}</h6>
        <p class="text-muted">{{ module.description }}</p>
      </div>
      <div class="ms-auto d-flex">
        <span
          role="button"
          class="badge bg-warning"
          title="Editar Módulo"
          @click="$emit('editModule', module.id)"
        >
          Editar
        </span>
        <span
          role="button"
          class="badge bg-dark ms-2"
          title="Exibir/Ocultar Aulas"
          @click="module.showLesson = !module.showLesson"
        >
          Exibir Aulas
        </span>
      </div>
    </div>
    <div v-if="module.showLesson" class="card-body">
      <LessonsModules :courseId="module.courseId" :moduleId="module.id" />
    </div>
    <div class="card-footer">
      <ul class="list-inline text-muted mb-0">
        <li class="list-inline-item">
          Cadastrado por:
          {{ createdUpdatedUser(module.createdBy, module.createdAt) }}
        </li>
        <li class="list-inline-item">
          Atualizado por:
          {{ createdUpdatedUser(module.updatedBy, module.updatedAt) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import LessonsModules from '@/components/courses/lessons/LessonsModules.vue'
import { createdUpdatedUser } from '@/utils/strings'

export default {
  name: 'ListModules',

  components: {
    LessonsModules,
  },

  props: {
    modules: {
      type: Array,
      required: true,
    },
  },

  emits: ['editModule'],

  data() {
    return {
      createdUpdatedUser,
    }
  },
}
</script>
